export const lightThemeVariables = {
    '--main-accent-color': '#4E95FF',
    '--main-title-color': '#202939',
    '--main-text-color': '#4B5565',
    '--footer-one-line-color': '#E4F1FF',
    '--main-button-border-radius': '9993px',
    '--main-button-background': 'linear-gradient(180deg, #80B3FF 0%, #3989FF 100%)',
    '--main-button-box-shadow': '0 4px 0 #376AB5',
    '--main-button-text': '#FFF',
    '--main-button-text-transform': 'uppercase',
    '--global-web-app-loader-border': '#4E95FF',
    '--global-web-app-loader-border-bottom': '#0f5bce',
    '--global-web-app-loader-background': '#EEF2F6',
    '--progres-bar': '#EEF2F6',
    '--progres-bar-active': '#4E95FF',
    '--quiz-custom-progress-bar': '#EEF2F6',
    '--quiz-custom-progress-bar-active': '#4E95FF',
    '--quiz-custom-progress-bar-part-text': '#4E95FF',
    '--quiz-custom-progress-bar-part-text-newt2': '#202939',
    '--quiz-go-back-button-background': '#f8f8f8',
    '--quiz-go-back-button-shadow': '#F7F7F7',
    '--quiz-go-back-button-text': '#202939',
    '--quiz-info-type-text': '#202939',
    '--background-color': '#FFF',
    '--title-default-color': '#202939',
    '--title-accent-color': '#4788E8',
    '--sub-title-default-color': '#4B5565',
    '--sub-title-default-color-quiz': '#4B5565',
    '--radio-button-background-color-quiz': '#FCFCFD',
    '--radio-button-border-color-quiz': '#CDD5DF',
    '--radio-button-border-hover-color-quiz': '#4E95FF',
    '--radio-button-border-hover-color-quiz-new-h2': '#4E95FF',
    '--radio-button-border-hover-color-quiz-new-s': '#4E95FF',
    '--kickstarter-main-block-border': '#4E95FF',
    '--kickstarter-main-block-background-gradient-1': '#AECEFF',
    '--kickstarter-main-block-background-gradient-2': '#F0F6FF',
    '--game-button-main-color': '#FCFCFD',
    '--game-button-main-border': '#CDD5DF',
    '--game-button-main-shadow': '#4E95FF80',
    '--game-button-main-shadow-visual-game': 'rgba(3, 212, 175, 0.50)',
    '--game-button-main-shadow-number-face-game': 'rgba(78, 149, 255, 0.50)',
    '--game-background-main-color': '#FCFCFD',
    '--game-tile-clicked-before': '#4BEEB3',
    '--game-tile-clicked-before-shadow': '#4BEEB3',
    '--game-tile-clicked-before-sequence': 'rgba(3, 212, 175, 0.10)',
    '--game-tile': '#EEF2F6',
    '--game-tile-before-sequence': '#2263C3',
    '--game-tile-choice-sequence': '#88B8FF',
    '--game-tile-hover': '#9AA4B2',
    '--game-progress-bar-background': '#EEF2F6',
    '--game-progress-bar-progress': '#3989FF',
    '--game-tile-hint-background': 'rgb(89, 19, 155)',
    '--game-visual-element-background': 'rgba(221, 221, 221, 0.5)',
    '--social-proof-background': 'rgba(221, 221, 221, 0.5)',
    '--loader-progress': '#3989FF',
    '--loader-progress-background': '#CDD5DF',
    '--loader-background': '#FFF',
    '--loader-review-background': '#EEF2F6',
    '--new-s-loader-progress': '#3989FF',
    '--new-s-loader-progress-background': '#CDD5DF',
    '--new-s-loader-progress-text': '#202939',
    '--new-s-loader-title-accent': '#4788E8',
    '--new-s-loader-secondary-text': '#202939',
    '--new-s-loader-review-background': '#EEF2F6',
    '--new-h2-loader-progress': '#3989FF',
    '--new-h2-loader-progress-background': '#CDD5DF',
    '--new-h2-loader-progress-text': '#202939',
    '--new-h2-loader-title-accent': '#4788E8',
    '--new-h2-loader-secondary-text': '#202939',
    '--new-h2-loader-review-background': '#EEF2F6',
    '--social-proof-memory-level-background-gradient-1': '#E5ECFF',
    '--social-proof-memory-level-background-gradient-2': '#F4F7FF',
    '--social-proof-left-text': '#C9783A',
    '--social-proof-green-text': '#00C2A0',
    '--social-proof-bottom-text': '#434343',
    '--plan-page-top-discount-background': 'rgba(255, 255, 255, 0.90)',
    '--plan-page-top-discount-bottom-border': 'rgba(177, 150, 255, 0.10)',
    '--plan-page-paywall-background-newt2': '#FCFCFD',
    '--plan-page-paywall-shadow-newt2': 'rgba(150, 150, 150, 0.25)',
    '--plan-page-paywall-promocode-border-newt2': '#4E95FF',
    '--plan-page-paywall-promocode-background-newt2': '#FCFCFD',
    '--plan-page-paywall-promocode-text-container-newt2': 'rgba(237, 237, 237, 1)',
    '--plan-page-paywall-timer-container-border-newt2': 'rgba(207, 92, 92, 1)',
    '--plan-page-paywall-timer-container-background-newt2': 'rgba(255, 224, 224, 1)',
    '--plan-page-img-title-default-color-newt2': 'rgba(32, 41, 57, 1)',
    '--plan-page-img-sub-title-default-color-newt2': 'rgba(75, 85, 101, 1)',
    '--plan-page-within-container-background': 'rgba(252, 252, 253, 1)',
    '--plan-page-within-element-background': 'rgba(148, 169, 207, 0.20)',
    '--plan-page-img-module-border-background': 'rgba(78, 149, 255, 0.00)',
    '--plan-page-img-module-background-gradient-1': 'rgba(251, 251, 251, 0.95)',
    '--plan-page-img-module-background-gradient-2': 'rgba(235, 243, 255, 0.95)',
    '--plan-page-img-module-title-default-color': '#F6F5F7',
    '--plan-page-img-module-bage-background': '#5B738F',
    '--plan-page-img-module-left-bage-background': '#3C4A61',
    '--plan-page-img-module-left-bage-text': '#F6F5F7',
    '--plan-page-img-module-right-bage-background': '#4BEEB3',
    '--plan-page-img-module-right-bage-text': '#151320',
    '--plan-page-img-module-bage-text-bottom': '#202939',
    '--plan-page-trust-memoryos-text': '#202939',
    '--plan-page-option-background-gradient-1': '#FCFCFD',
    '--plan-page-option-background-gradient-2': '#FCFCFD',
    '--plan-page-option-background-border': '#CDD5DF',
    '--plan-page-option-background-active-gradient-1': '#FBFBFB',
    '--plan-page-option-background-active-gradient-2': '#EBF3FF',
    '--plan-page-option-background-active-border': '#4E95FF',
    '--plan-page-option-most-popular-background': '#5B738F',
    '--plan-page-option-most-popular-text': '#FFF',
    '--plan-page-option-title': '#202939',
    '--plan-page-option-save-bage-background': 'rgba(75, 238, 179, 0.70)',
    '--plan-page-option-save-bage-text': '#151320',
    '--plan-page-option-part-text': '#88B8FF',
    '--plan-page-option-secured-text': '#4B5565',
    '--plan-page-option-safe-background': 'rgba(75, 238, 179, 0.2)',
    '--plan-page-option-safe-text': '#4beeb3',
    '--plan-page-option-details-text': '#4B5565',
    '--plan-page-down-sale-popup-accent-text': '#88B8FF',
    '--plan-page-title': '#F6F5F7',
    '--plan-page-title-accent': '#4E95FF',
    '--plan-page-sub-title': '#4B5565',
    '--plan-page-header-background': '#F5F5F5',
    '--plan-page-promocode-background': 'rgba(252,252,253, 0.9)',
    '--plan-page-promocode-border': '#4E95FF',
    '--plan-page-element-background': 'rgba(252,252,253,1)',
    '--plan-page-memorize-elements-background': 'rgba(148,169,207, 0.3)',
    '--plan-page-open-text': '#3989FF',
    '--plan-page-one-line-border': '#E4F1FF',
    '--plan-page-bottom-button-shadow-background': 'rgba(252,252,253, 0.9)',
    '--plan-page-viewing-page-counter-background': '#5B738F',
    '--plan-page-viewing-page-counter-text': '#F6F5F7',
    '--plan-page-options-container-shadow': 'rgba(96, 154, 255, 0.3)',
    '--plan-page-modal-background': 'rgb(252,252,253)',
    '--plan-page-review-arrow-background': 'rgba(252, 252, 253, 1)',
    '--plan-page-review-arrow-border': 'rgba(78, 149, 255, 1)',
    '--plan-page-options-secure-text': '#4B5565',
    '--plan-page-options-footer-safe-background': 'rgba(75, 238, 179, 0.20)',
    '--plan-page-options-footer-safe-text': '#01B474',
    '--plan-page-button-newt2-background-gradient-1': '#5D53F0',
    '--plan-page-button-newt2-background-gradient-2': '#6242ED',
    '--payment-page-background-newt2': '#FFF',
    '--payment-page-details-background-newt2': 'rgba(21, 19, 32, 0.80)',
    '--payment-page-checkbox-text-newt2': '#697586',
    '--plan-page-button-iq-test-background-gradient-1': '#5D53F0',
    '--plan-page-button-iq-test-background-gradient-2': '#6242ED',
    '--offer-page-price-text': '#4B5565',
    '--offer-page-cross-price-text': '#4B5565',
    '--offer-page-pagination-bullet': 'rgba(32, 41, 57, 0.4)',
    '--offer-page-pagination-bullet-active': 'rgba(32, 41, 57, 1)',
    '--offer-page-badge-newt2': 'rgba(247, 41, 0, 0.8)',
    '--offer-page-text-newt2': 'rgba(0, 0, 0, 0.80)',
    '--offer-page-subtitle-newt2': 'rgba(75, 85, 101, 1)',
    '--offer-page-workbook-container-border-newt2': 'rgba(78, 149, 255, 1)',
    '--offer-page-workbook-badge-border-newt2': '#4E95FF',
    '--offer-page-workbook-badge-background-newt2': '#5C9DFF',
    '--offer-page-workbook-main-block-newt2': '#FCFCFD',
    '--offer-page-badge-iq-test': 'rgba(247, 41, 0, 0.8)',
    '--offer-page-text-iq-test': 'rgba(0, 0, 0, 0.80)',
    '--offer-page-subtitle-iq-test': 'rgba(75, 85, 101, 1)',
    '--offer-page-workbook-container-border-iq-test': 'rgba(78, 149, 255, 1)',
    '--offer-page-workbook-badge-border-iq-test': '#4E95FF',
    '--offer-page-workbook-badge-background-iq-test': '#5C9DFF',
    '--offer-page-workbook-main-block-iq-test': '#FCFCFD',
    '--offer-page-paywall-title': '#4B5565',
    '--offer-page-paywall-save-text': '#AE1D00',
    '--offer-page-paywall-save-text-border': '#AE1D00',
    '--offer-page-paywall-save-text-background': 'rgba(247, 41, 0, 0.10)',
    '--offer-page-scroll-button-background': 'rgba(239, 239, 239, 0.8)',
    '--offer-page-user-container-border': '#4E95FF',
    '--offer-page-user-container-background': '#FCFCFD',
    '--offer-page-mastery-list-border': 'rgba(255, 255, 255, 0.00)',
    '--offer-page-mastery-list-background-gradient-1': 'rgba(236, 244, 255, 1)',
    '--offer-page-mastery-list-background-gradient-2': 'rgba(191, 218, 255, 1)',
    '--offer-page-loci-badge-background': 'rgba(247, 41, 0, 0.8)',
    '--signup-bottom-block-border': '#4E95FF',
    '--signup-bottom-block-background': '#FCFCFD',
    '--thankyou-header-background': 'rgba(255, 255, 255, 0.90)',
    '--thankyou-page-one-line-border': 'rgba(177, 150, 255, 0.10)',
    '--thankyou-page-sub-border-color': '#4E95FF',
    '--thankyou-page-sub-background-color-one': '#FCFCFD',
    '--thankyou-page-sub-background-color-two': '#FCFCFD',
    '--thankyou-page-sub-shadow': 'rgba(41, 30, 82, 0.12)',
    '--thankyou-page-sub-welcome-text': '#202939',
    '--thankyou-page-sub-text': '#3989FF',
    '--thankyou-page-sub-renew-test': '#202939',
    '--thankyou-page-sub-loci-text': '#4BEEB3',
    '--thankyou-page-steps-header-text': '#202939',
    '--thankyou-page-step-border': '#4E95FF',
    '--thankyou-page-step-background-gradient-1': '#F9FAFB',
    '--thankyou-page-step-background-gradient-2': '#ECF4FF',
    '--thankyou-page-step-number-color-one': '#4E95FF',
    '--thankyou-page-step-number-color-two': '#715AFF',
    '--thankyou-page-step-header': '#202939',
    '--thankyou-page-step-regular-text': '#202939',
    '--thankyou-page-step-sub-title': '#88B8FF',
    '--thankyou-page-step-google-text': '#151320',
    '--thankyou-page-step-google-border': '#C4C8D9',
    '--thankyou-page-step-google-background': '#FFF',
    '--thankyou-page-step-apple-text': '#FFFFFF',
    '--thankyou-page-step-apple-background': '#000',
    '--thankyou-page-step-download-button-border': '#696680',
    '--thankyou-page-step-download-button-background': 'rgba(21, 19, 32, 0.50)',
    '--thankyou-page-step-download-button-text-header': '#E8EDFF',
    '--thankyou-page-step-download-button-text-footer': '#E8EDFF',
    '--thankyou-page-step-block-background': 'rgba(78, 149, 255, 0.10)',
    '--thankyou-page-gamepad-background-gradient-1': '#F9FAFB',
    '--thankyou-page-gamepad-background-gradient-2': '#ECF4FF',
    '--thankyou-page-notification-container-background-gradient-1': '#FCFCFD',
    '--thankyou-page-notification-container-background-gradient-2': '#FCFCFD',
    '--thankyou-page-notification-container-border': '#4E95FF',
    '--thankyou-page-notification-container-text': '#202939',
    '--thankyou-page-iq-test-border': '#80B3FF',
    '--thankyou-page-bottom-header-button-text': '#202939',
    '--thankyou-page-bottom-button-text': '#E8EDFF',
    '--thankyou-page-bottom-button-background': 'rgba(21, 19, 32, 0.50)',
    '--regular-quiz-loader-popup-wrapper-background': 'rgba(13, 18, 28, 0.70)',
    '--regular-quiz-loader-popup-border': '#CDD5DF',
    '--regular-quiz-loader-popup-background': '#FCFCFD',
    '--regular-quiz-loader-popup-title': '#4B5565',
    '--regular-quiz-loader-popup-question': '#202939',
    '--regular-quiz-loader-popup-button-text': '#202939',
    '--regular-quiz-loader-popup-button-background': 'rgba(238, 238, 238, 0.5)',
    '--regular-quiz-loader-popup-button-background-active': 'rgba(238, 238, 238, 1)',
    '--regular-quiz-loader-popup-button-shadow': 'rgba(214, 214, 214, 0.8)',
    '--regular-quiz-loader-popup-button-shadow-active': 'rgba(213, 213, 213, 0.5)',
    '--regular-quiz-loader-hr-line': '#4B5565',
    '--upsell-jonas-ai-header-button-text': 'rgba(0, 0, 0, 0.80)',
    '--upsell-jonas-ai-header-border-bottom': 'rgba(150, 176, 255, 0.10)',
    '--upsell-jonas-ai-badge-background': 'rgba(247, 41, 0, 0.80)',
    '--upsell-jonas-ai-message-border': '#D4E7FF',
    '--upsell-jonas-ai-message-background': 'rgba(255, 255, 255, 0.70)',
    '--upsell-jonas-ai-chat-preview-background': 'linear-gradient(73deg, rgba(236, 244, 255, 0.95) 0.01%, rgba(191, 218, 255, 0.95) 100%)',
    '--upsell-jonas-ai-feature-card-border': '#4E95FF',
    '--upsell-jonas-ai-feature-card-background': '#FCFCFD',
    '--upsell-jonas-ai-feature-card-badge-background': '#5B738F',
    '--upsell-jonas-ai-payment-block-border': '#4E95FF',
    '--upsell-jonas-ai-payment-block-background': '#FCFCFD',
    '--upsell-jonas-ai-offer-price-background': 'rgba(247, 41, 0, 0.10)',
    '--upsell-jonas-ai-offer-text-color': '#AE1D00',
    '--upsell-jonas-ai-memory-grandmaster-background': 'linear-gradient(73deg, rgba(236, 244, 255, 0.95) 0.01%, rgba(191, 218, 255, 0.95) 100%)',
    '--upsell-jonas-ai-feedback-border': '#4E95FF',
    '--upsell-jonas-ai-feedback-background': '#FCFCFD',
    '--upsell-jonas-ai-shadow': 'linear-gradient(270deg, #FFFFFF 6.49%, rgba(255, 255, 255, 0) 95.19%)',
    '--upsell-jonas-ai-feedback-arrow-border': '#4E95FF',
    '--upsell-jonas-ai-feedback-arrow-background': '#FCFCFD',
    '--upsell-jonas-ai-bottom-block-background': 'linear-gradient(253deg, rgba(236, 244, 255, 0.95) 0.01%, rgba(191, 218, 255, 0.95) 100%)',
    '--upsell-jonas-ai-guarantee-background': 'linear-gradient(73deg, rgba(236, 244, 255, 0.95) 0.01%, rgba(191, 218, 255, 0.95) 100%)',
    '--upsell-jonas-ai-scroll-button-background': 'rgba(255, 255, 255, 0.8)',
    '--reserve-page-accent-color': '#4E95FF',
    '--reserve-page-top-header-background': '#FFF',
    '--reserve-page-top-header-border-bottom': '#E4F1FF',
    '--reserve-page-top-component-border': '#4E95FF',
    '--reserve-page-top-component-background': '#FCFCFD',
    '--reserve-page-top-component-box-border': '#208FFE',
    '--reserve-page-top-component-box-background': 'linear-gradient(215deg, rgba(195, 226, 255, 0.30) 1.53%, rgba(165, 204, 255, 0.60) 95.82%)',
    '--reserve-page-jonas-component-box-shadow': '0 70px 200px 0 rgba(78, 149, 255, 0.36)',
    '--reserve-page-main-component-border': 'rgba(78, 149, 255, 0.00)',
    '--reserve-page-main-component-background': 'linear-gradient(73deg, rgba(251, 251, 251, 0.95) 0%, rgba(235, 243, 255, 0.95) 100%)',
    '--reserve-page-main-component-box-shadow': '0 70px 200px 0 rgba(78, 149, 255, 0.12)',
    '--reserve-page-bottom-component-border': '78, 149, 255',
    '--reserve-page-bottom-component-background': 'linear-gradient(0deg, rgba(235, 243, 255, 0.95) 0%, rgba(235, 243, 255, 0.95) 100%)',
    '--waitlist-page-top-component-border': 'rgba(78, 149, 255, 0.2)',
    '--waitlist-page-top-component-background': 'linear-gradient(73deg, rgba(251, 251, 251, 0.95) 0%, rgba(235, 243, 255, 0.95) 100%)',
    '--waitlist-page-video-box-shadow': '0 16px 60px 0 rgba(78, 149, 255, 0.30)',
    '--waitlist-page-within-memory-os-box-shadow': '0px 16px 120px 0px rgba(78, 149, 255, 0.3)',
    '--waitlist-page-within-memory-os-item-background': 'rgba(148, 169, 207, 0.20)',
    '--waitlist-page-award-box-background': 'linear-gradient(73deg, rgba(251, 251, 251, 0.95) 0%, rgba(235, 243, 255, 0.95) 100%)',
    '--waitlist-page-award-box-border': '78, 149, 255',
    '--waitlist-page-award-box-border-left': '78, 149, 255',
    '--waitlist-page-more-effeciently-border': '#E4F1FF',
    '--waitlist-page-moew-effecientky-box-border': '#4E95FF',
    '--waitlist-page-moew-effecientky-box-background': 'rgba(252, 252, 253, 0.95)',
    '--waitlist-page-moew-effecientky-box-shadow': 'linear-gradient(73deg, rgba(251, 251, 251, 0.95) 0%, rgba(235, 243, 255, 0.95) 100%)',
    '--waitlist-page-feedback-border': '#4E95FF',
    '--waitlist-page-feedback-background': '#FCFCFD',
    '--waitlist-page-slider-arrow-border': '#4E95FF',
    '--waitlist-page-slider-arrow-background': '#FCFCFD',
    '--waitlist-page-decoration-background': 'linear-gradient(270deg, #FFFFFF 6.49%, rgba(255, 255, 255, 0) 95.19%)',
    '--waitlist-page-offen-ask-border': '#4E95FF',
    '--waitlist-page-offen-ask-background': '#FCFCFD',
    '--waitlist-page-viewing-box-background': '#5B738F',
    '--web-to-app-reading-text-color': '#4B5565',
    '--web-to-app-reading-border-color': '#CDD5DF',
    '--web-to-app-lessons-tab-border-color': '#4B5565',
    '--web-to-app-lessons-tab-color-active': '#FCFCFD',
    '--web-to-app-lessons-tab-background-active': '#202939',
    '--web-to-app-lessons-quote-background': '#C8DEFF',
} as const;
